import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from './ui/badge';
import { formatPrice } from '../lib/currency';
import { MapPin, Clock, Eye, Heart, BadgeCheck } from 'lucide-react';

export const ItineraryCard = ({ it, currency = 'INR' }) => (
  <Link to={`/creators/${it.creator_username}/itineraries/${it.slug}`}
    className="group rounded-2xl border border-border bg-card overflow-hidden card-elevate flex flex-col" data-testid="itinerary-card">
    <div className="h-44 relative overflow-hidden">
      <img src={it.cover_image || 'https://images.unsplash.com/photo-1502920917128-1aa500764cbd?w=800&q=80'} alt={it.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-primary/70 to-transparent" />
      {it.content_type === 'sponsored' && <Badge className="absolute top-2 left-2 bg-amber-500 text-white rounded-full text-[10px]">Sponsored</Badge>}
      {it.trip_type && <Badge className="absolute top-2 right-2 bg-card/90 text-foreground rounded-full text-[10px] capitalize">{it.trip_type}</Badge>}
      <div className="absolute bottom-2 left-3 right-3 text-primary-foreground">
        <p className="font-display font-semibold leading-tight line-clamp-2">{it.title}</p>
      </div>
    </div>
    <div className="p-4 flex flex-col flex-1">
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3" /> {it.destination}</span>
        <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3" /> {it.duration_days}d</span>
      </div>
      <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{it.short_description}</p>
      <div className="mt-auto pt-3 flex items-center justify-between">
        <span className="text-xs text-muted-foreground">by <span className="font-medium text-foreground">@{it.creator_username}</span></span>
        <span className="flex items-center gap-2 text-xs text-muted-foreground">
          <span className="inline-flex items-center gap-1"><Eye className="h-3 w-3" /> {it.stats?.views || 0}</span>
          {it.estimated_budget ? <span className="font-semibold text-foreground">{formatPrice(it.estimated_budget, currency)}</span> : null}
        </span>
      </div>
    </div>
  </Link>
);
